<template>
  <div class="main-content">
    <!-- HEADER -->
    <div class="header">
      <div class="container-fluid">
        <div class="card mt-5">
          <div class="card-body">
            <div class="row justify-content-between align-items-center">
              <div class="col-12 col-md-9 col-xl-7">
                <!-- Heading -->
                <h2 class="mb-2">E-Mustering : {{ details.title }}</h2>

                <!-- Text -->
                <p class="text-muted mb-md-0">{{ details.description }}</p>
              </div>
              <div class="col-12 col-md-auto"></div>
            </div>
          </div>
        </div>
        <!-- Body -->
      </div>
    </div>
    <!-- / .header -->

    <!-- CARDS -->
    <div class="container-fluid">
      <!-- / .row -->
      <div class="row">
        <div class="col-12">
          <!-- Convertions -->
          <div class="card">
            <div class="card-header">
              <!-- Title -->
              <h4 class="card-header-title">Detail Mustering Area</h4>
            </div>
            <div class="card-body">
              <div class="d-flex justify-content-start mb-3">
                <label>Area</label>
                <v-select
                  class="form-group col-4"
                  v-model="impacted_area"
                  label="location_name"
                  :reduce="(option) => option.id"
                  :options="detail.area"
                  v-validate="'required'"
                  @input="pickLocation"
                />
              </div>
              <div class="row" v-if="filterArea.length > 0">
                <div class="col-xl-3 col-lg-4 col-md-6 col-sm-12" v-for="(item, index) in filterArea" :key="index">
                  <div
                    class="card"
                  >
                    <img
                      :src="`https://profpic.ugems.id/${item.nik}.jpg`"
                      class="navbar-brand-img mx-auto"
                      style="padding: 20px"
                      alt="..."
                      @error="$event.target.src='https://cdn-icons-png.flaticon.com/512/1018/1018662.png'"
                    />
                    <div class="card-body text-center">
                      <h2>{{ item.fullname }}</h2>
                      <p>{{ item.position_name }}</p>
                      <p>{{ item.company_name }}</p>
                      <div class="d-flex justify-content-center mb-3">
                        <p class="col-auto">Status: </p>
                        <p
                          class="col-auto"
                          v-if="item.status == 'safe'"
                          style="color: green"
                        >
                          Safe
                        </p>
                        <p
                          class="col-auto"
                          v-else-if="item.status == 'unsafe'"
                          style="color: red"
                        >
                          Unsafe
                        </p>
                        <p class="col-auto" v-else>
                          {{ item.status }}
                        </p>
                        <svg
                          v-if="item.status == 'unsafe'"
                          class="col-auto"
                          xmlns="http://www.w3.org/2000/svg"
                          xmlns:xlink="http://www.w3.org/1999/xlink"
                          viewBox="0,0,256,256"
                          width="20px"
                          height="20px"
                          fill-rule="nonzero"
                        >
                          <g
                            fill="#ff0000"
                            fill-rule="nonzero"
                            stroke="none"
                            stroke-width="1"
                            stroke-linecap="butt"
                            stroke-linejoin="miter"
                            stroke-miterlimit="10"
                            stroke-dasharray=""
                            stroke-dashoffset="0"
                            font-family="none"
                            font-weight="none"
                            font-size="none"
                            text-anchor="none"
                            style="mix-blend-mode: normal"
                          >
                            <g transform="scale(5.12,5.12)">
                              <path
                                d="M25,2c-12.703,0 -23,10.297 -23,23c0,12.703 10.297,23 23,23c12.703,0 23,-10.297 23,-23c0,-12.703 -10.297,-23 -23,-23zM25,11c1.657,0 3,1.343 3,3c0,1.657 -1.343,3 -3,3c-1.657,0 -3,-1.343 -3,-3c0,-1.657 1.343,-3 3,-3zM29,38h-2h-4h-2v-2h2v-13h-2v-2h2h4v2v13h2z"
                              ></path>
                            </g>
                          </g>
                        </svg>
                        <svg
                          v-else-if="item.status == 'safe'"
                          class="col-auto"
                          xmlns="http://www.w3.org/2000/svg"
                          xmlns:xlink="http://www.w3.org/1999/xlink"
                          viewBox="0,0,256,256"
                          width="20px"
                          height="20px"
                          fill-rule="nonzero"
                        >
                          <g
                            fill="none"
                            fill-rule="nonzero"
                            stroke="none"
                            stroke-width="1"
                            stroke-linecap="butt"
                            stroke-linejoin="miter"
                            stroke-miterlimit="10"
                            stroke-dasharray=""
                            stroke-dashoffset="0"
                            font-family="none"
                            font-weight="none"
                            font-size="none"
                            text-anchor="none"
                            style="mix-blend-mode: normal"
                          >
                            <g transform="scale(5.33333,5.33333)">
                              <path
                                d="M44,24c0,11.045 -8.955,20 -20,20c-11.045,0 -20,-8.955 -20,-20c0,-11.045 8.955,-20 20,-20c11.045,0 20,8.955 20,20z"
                                fill="#009305"
                              ></path>
                              <path
                                d="M34.586,14.586l-13.57,13.586l-5.602,-5.586l-2.828,2.828l8.434,8.414l16.395,-16.414z"
                                fill="#ffffff"
                              ></path>
                            </g>
                          </g>
                        </svg>
                        <p class="col-auto" v-else></p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <b-alert v-if="isFiltered && filterArea.length == 0" show variant="success">There is no employee in the area</b-alert>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <!-- / .main-content -->
</template>
<script>
import "../../assets/js/theme.bundle";
import "../../assets/js/vendor.bundle";
import moment from "moment";

export default {
  name: "restrictedAreaComponent",
  computed: {
    detail() {
      return this.$store.getters["mustering/detail"];
    },
  },
  data() {
    return {
      isFiltered: false,
      filterArea: [],
      details: {},
      impacted_area: "",
    };
  },
  mounted() {
    this.getDetail();
  },
  methods: {
    getDetail() {
      console.log('uhuy');
      const id = this.$router.currentRoute.params["id"];
      this.$store.dispatch("mustering/DETAIL", { id }).then(() => {
        const detail = this.detail;
        this.details = detail
        // let data_area = detail.map((item) => {
        //   console.log('item', item);
        //   return {
        //     location_id: item.location_id,
        //     person: item.person
        //   };
        // });
        // var filters = data_area.filter((i) => {
        //   return i.location_id == this.impacted_area;
        // });
        // this.filterArea = filters[0].person;
        // console.log(this.filterArea);
        // console.log(this.impacted_area);
      });
    },
    pickLocation (e) {
      console.log('e', e);
      if (e) {
        var area = this.details.area
  
        var filters = area.filter((i) => {
          console.log('area filter', i);
          return i.id == e;
        });
        this.filterArea = filters[0].person;
        this.isFiltered = true
      } else {
        this.filterArea = []
        this.isFiltered = false
      }
    }
  },
};
</script>
